import { mainApi } from "services/main";
import {
  ListGuestsRequest,
  ListGuestsResponse,
  ListMemberRequest,
  ListMemberResponse,
  UIContentRequest,
  UIContentResponse,
} from "./definitions";

const extendedApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    getUIContent: builder.query<UIContentResponse, UIContentRequest>({
      query: (request: UIContentRequest) => ({
        url: "uicontent/" + request.teamName + "/" + request.page,
      }),
    }),
    getListMember: builder.query<ListMemberResponse, ListMemberRequest>({
      query: (request: ListMemberRequest) => ({
        url: "permission/members/" + request.teamName,
      }),
    }),
    listGuests: builder.query<ListGuestsResponse, ListGuestsRequest>({
      query: (request: ListGuestsRequest) => ({
        url: "permission/guests/" + request.resourceId,
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetUIContentQuery,
  useGetListMemberQuery,
  useListGuestsQuery,
  usePrefetch,
} = extendedApi;
